import React from "react";
import { makeShellT } from "./i18n/index.js";

/* Minimal error boundary around the imported prototype. Keeps a crash from
   producing a blank white screen; does not alter prototype behavior. */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[Aurio] render error", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;

    const t = makeShellT();
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          background: "#0E1118",
          color: "#F2ECDC",
          fontFamily: "'Geist', system-ui, sans-serif",
          padding: 24,
          textAlign: "center",
        }}
      >
        <div style={{ maxWidth: 360 }}>
          <div style={{ fontFamily: "'Instrument Serif', serif", fontSize: 22, marginBottom: 10 }}>
            {t("app.error.title")}
          </div>
          <div style={{ color: "#9AA3B2", fontSize: 14, lineHeight: 1.6, marginBottom: 20 }}>
            {t("app.error.body")}
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: "#C9A227",
              color: "#0E1118",
              border: "none",
              borderRadius: 10,
              padding: "10px 18px",
              fontWeight: 600,
              fontSize: 14,
              cursor: "pointer",
            }}
          >
            {t("app.error.reload")}
          </button>
        </div>
      </div>
    );
  }
}
